import { fDateYMD } from '../../../utils/formatTime';
import { buildQuery } from '../../../utils/query';

// One query builder for the asset list, so paging and filtering cannot send
// different URLs: paging used to go through GET_ASSETS, which knew nothing
// about the filters, so page 2 of a branch's assets came back unfiltered.
const assetListQuery = ({
  page = 1,
  rowsPerPage = 10,
  locationId,
  categoryId,
  assetStatus,
  startDate,
  endDate,
  barcodeNumber,
  searchTerm,
} = {}) =>
  buildQuery({
    page,
    page_size: rowsPerPage,
    location_id: locationId,
    category_id: categoryId,
    // The API reads this as `status`; it was sent as `asset_status`, which it
    // ignored, so filtering by status quietly did nothing.
    status: assetStatus,
    start_date: startDate ? fDateYMD(startDate) : '',
    end_date: endDate ? fDateYMD(endDate) : '',
    barcode_number: barcodeNumber,
    // The search box: one term, matched against everything the API can search
    // an asset by, alongside (not instead of) the filters above.
    search_term: searchTerm,
  });

export default {
  GET_ASSETS: (params) => `assets/${assetListQuery(params)}`,
  GET_ASSET_TRANSFERS: ({
    page = 1,
    rowsPerPage = 10,
    locationId,
    transferStatus,
    custodianStatus,
    startDate,
    endDate,
    searchTerm,
  } = {}) =>
    `assets/transfers/${buildQuery({
      page,
      page_size: rowsPerPage,
      location_id: locationId,
      status: transferStatus,
      custodian_status: custodianStatus,
      start_date: startDate ? fDateYMD(startDate) : '',
      end_date: endDate ? fDateYMD(endDate) : '',
      search_term: searchTerm,
    })}`,
  GET_ASSET_TRANSFER_ITEMS: ({ id, page = 1, rowsPerPage = 10 }) =>
    `assets/transfers/${id}/items/?page=${page}&page_size=${rowsPerPage}`,
  APPROVE_ASSET_TRANSFER: (id) => `assets/transfers/${id}/approve/`,
  DECLINE_ASSET_TRANSFER: (id) => `assets/transfers/${id}/decline/`,
  ACCEPT_ASSET_TRANSFER: (id) => `assets/transfers/${id}/accept/`,
  REJECT_ASSET_TRANSFER: (id) => `assets/transfers/${id}/reject/`,
  FILTER_ASSETS: (params) => `assets/${assetListQuery(params)}`,
  GET_ASSET: (id) => `assets/${id}/`,
  TRANSFER_ASSET: 'assets/transfers/',
  CREATE_ASSET: 'assets/',
  UPLOAD_ASSET: 'assets/asset-import/',
  UPDATE_ASSET: (id) => `assets/${id}/`,
  DELETE_ASSET: (id) => `assets/${id}/`,
};
